document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".swiper").forEach((swiperEl) => {
    new Swiper(swiperEl, {
      direction: "horizontal",
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },
      slidesPerView: 1,
    });
  });
});
